module.exports = __webpack_public_path__ + "f19899a0468b6d22da72bfaf5c69003d.png";